import { inventoryCategoryService } from "../../../../../Api/Services/InventoryService/inventoryCategory";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ICreateInventoryCategoryResponse, IInventoryCategoryPayload } from "../../types";

export const saveUpdateInventoryCategory = createServiceAsyncThunk<
  ICreateInventoryCategoryResponse,
  IInventoryCategoryPayload
>(
  ACTION_NAMES.SAVE_UPDATE_INVENTORY_CATEGORY,
  (payload) => inventoryCategoryService.saveOrUpdateInventoryCategory(payload),
  ERROR_MESSAGES.SAVE_UPDATE_INVENTORY_CATEGORY_FAILURE
);

const saveUpdateInventoryCategorySlice = createGenericSlice<
  ICreateInventoryCategoryResponse,
  IInventoryCategoryPayload
>(
  SLICE_NAMES.SAVE_UPDATE_INVENTORY_CATEGORY_SLICE,
  saveUpdateInventoryCategory
);

export const {
  clearError: clearSaveInventoryCategoryError,
  clearSuccessMessage: clearSaveInventoryCategorySuccessMessage,
} = saveUpdateInventoryCategorySlice.actions;

export default saveUpdateInventoryCategorySlice.reducer;
